import { ArrowRight } from "lucide-react";
import { AuvpLogo } from "./AuvpLogo";

const CREDIT_URL = "https://credito.auvpcapital.com.br/?utm_term=amortizador";

export function CreditBanner() {
  return (
    <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-[#093618] to-[#041a0d] p-6 shadow-md sm:p-8">
      {/* Decorative blur */}
      <div
        className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-yellow-400/15 blur-3xl"
        aria-hidden
      />
      <div className="relative flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-2xl">
          <h3 className="text-xl font-semibold tracking-tight text-white sm:text-2xl">
            Precisa de crédito com melhores condições?
          </h3>
          <p className="mt-2 text-sm font-medium text-white/80 sm:text-base">
            A AUVP compara opções em mais de 20 instituições financeiras para encontrar a solução
            mais adequada ao seu perfil.
          </p>
        </div>
        <div className="flex shrink-0 flex-col items-start gap-3 max-sm:items-center max-sm:w-full max-sm:justify-center">
          <AuvpLogo className="h-14 w-auto" fill="#ffffff" />
          <a
            href={CREDIT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex gap-2 rounded-lg bg-[#977d31] px-5 py-3 text-sm font-semibold text-white shadow-sm transition-transform hover:scale-105 max-sm:w-full justify-center items-center"
          >
            Simular agora
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
  );
}
